var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurriculums(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_twotone_receipt-text",
    "data-name": "vuesax/twotone/receipt-text",
    transform: "translate(-108 -444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "receipt-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6,4V6.42A2.4,2.4,0,0,1,3.42,9H0V2.01A2.019,2.019,0,0,1,2.02,0,3.995,3.995,0,0,1,6,4Z",
    transform: "translate(124 446)",
    fill: "none",
    stroke: "#2f468c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,5V19a1,1,0,0,0,1.6.8l1.71-1.28a1.007,1.007,0,0,1,1.32.1l1.66,1.67a1.008,1.008,0,0,0,1.42,0l1.68-1.68a.991.991,0,0,1,1.3-.09L12.4,19.8A1,1,0,0,0,14,19V2a2.006,2.006,0,0,1,2-2H4C1,0,0,1.79,0,4Z",
    transform: "translate(110 446)",
    fill: "none",
    stroke: "#2f468c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H6",
    transform: "translate(114 453)",
    fill: "none",
    stroke: "#f4347f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H4.5",
    transform: "translate(114.75 457)",
    fill: "none",
    stroke: "#f4347f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(108 444)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurriculums);
export default __webpack_public_path__ + "static/media/curriculums.3a53b046eb5f6ff16d9294c17753e7c6.svg";
export { ForwardRef as ReactComponent };